<br>
<p-panel>
  <div class="d-flex justify-content-left align-content-center">
    <div class="d-flex align-items-center gap-2">
      <h4 class="m-0" *ngIf="flag === 'edit'">
        {{ 'Editar ' + (horticola ? 'Cultivo' : 'Tarea Siembra') }}
      </h4>
      <h4 class="m-0" *ngIf="flag === 'new'">
        {{ 'Crear ' + (horticola ? 'Cultivo' : 'Tarea Siembra') }}
      </h4>
      <p-progressSpinner
        *ngIf="loadingCultivoVariedad"
        [style]="{ width: '18px', height: '18px' }"
        strokeWidth="6"
        animationDuration="1.5s">
      </p-progressSpinner>
    </div>
  </div>
  <div *ngIf="this.applicationType !== 'viverogest' && !this.horticola">
    <app-form-builder
        [model]="model"
        [distributionOrder]="distributionOrder"
        [distributionColumns]="4"
        [fields]="formFields"
        (formChanges)="formChanges($event)"
        (selectAllcheck)="selectAll()">
    </app-form-builder>
  </div>
  <div *ngIf="this.applicationType === 'viverogest' && !this.horticola">
    <app-form-builder
          [model]="model"
          [distributionOrder]="distributionOrderViverogest"
          [distributionColumns]="4"
          [fields]="formFieldsViverogest"
          (formChanges)="formChanges($event)"
          (selectAllcheck)="selectAll()">
    </app-form-builder>
    <app-dictado
    mensaje="Grabar observaciones" 
    [observaciones]="model.observaciones ?? ''" 
    (sendObservaciones)="getObservaciones($event)"
    ></app-dictado>
  </div>
  <div *ngIf="this.horticola">
    <app-form-builder
          [model]="model"
          [distributionOrder]="[2, 3, 2]"
          [distributionColumns]="3"
          [fields]="formFieldsHorticola"
          (formChanges)="formChanges($event)"
          (selectAllcheck)="selectAll()">
    </app-form-builder>
  </div>
  <div class="mb-5 col-sm-6" *ngIf="this.showTareasSiembraMaquinarias && !this.horticola">
    <h5>Datos de la maquinaria</h5>
    <app-form-builder
            [model]="model"
            (formChanges)="formChanges($event); formChanges($event)"
            [distributionColumns]="3"
            [fields]="formFieldsMaquinarias">
    </app-form-builder>
  </div>
  <br>
  <div class="d-flex justify-content-center">
    <div>
      <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
    </div>
    <app-request-button
            [lockOnSuccess]="true"
            (click)="submit()"
            [mode]="requestButtonType"
            [request]="request">
    </app-request-button>
  </div>
</p-panel>
<br>
